import { useEffect } from 'react';
import { caseStudySchema } from '../lib/route-meta.js';

// Article JSON-LD for a case study detail page. Renders no markup: it
// appends one <script type="application/ld+json"> to <head> and removes it
// on unmount, so navigating between case studies cannot leave a stale
// block describing the previous one behind.
//
// Google reads JSON-LD injected this way because it runs JS. Bots that do
// not are served the same block by middleware.js.
export default function CaseStudySchema({ caseStudy, slug }) {
  useEffect(() => {
    const schema = caseStudySchema(caseStudy, slug);
    if (!schema) return;

    // middleware.js has usually already written this block into the served
    // HTML. Appending a second one would leave two Article blocks in the
    // hydrated DOM, which is what a JS-running crawler (Google) reads. Take
    // over the existing block instead, and only create one if none is there
    // (client-side navigation between case studies, where no fresh document
    // was ever served).
    const existing = document.querySelector('script[type="application/ld+json"]');
    const el = existing || document.createElement('script');
    el.type = 'application/ld+json';
    el.setAttribute('data-margin-schema', 'case-study');
    el.textContent = JSON.stringify(schema);
    if (!existing) document.head.appendChild(el);

    return () => { el.remove(); };
  }, [caseStudy, slug]);

  return null;
}
